import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PaymentFailedForm from 'app/modules/payment/components/PaymentFailedForm';

@inject('store')
@observer
class CraneBookingPaymentFailed extends Component {
    constructor() {
        super();
        this.state = {
            total: null,
        };
    }

    async componentDidMount() {
        const { payment: { craneBooking } } = this.props.store;

        await craneBooking.extractTotalPayment();

        if (craneBooking.paymentTotalIndoor) {
            this.setState({ total: craneBooking.paymentTotalIndoor });
        }
    }

    render() {
        const { payment: { craneBooking: { paymentTotalIndoor } } } = this.props.store;

        return <PaymentFailedForm total={paymentTotalIndoor || this.state.total} />
    }
}

export default CraneBookingPaymentFailed;
